/* eslint-disable @typescript-eslint/no-unused-vars */
import trilhaImg from '../../../assets/assets/icons/trilhas/trilha_icon.svg';
import raceImg from '../../../assets/assets/icons/trilhas/race.svg';
import infoImg from '../../../assets/assets/info_button.svg';

import {
  TrilhaContainer,
  Trilha,
  Circle,
  CaminhoTrilha,
  TrilhaItem,
  TrilhaFooter,
  LineTrilha,
} from './styles';
import { useEffect, useState } from 'react';
import { useDashboard } from '../../../context/context/DashboardContext';

const tempoTrilhas = ['00:00:15', '00:00:25', '00:00:15', '00:00:13'];

export function Trilhas() {
  const [totalTempo, setTotalTempo] = useState('');
  const { dashboard } = useDashboard();
  function somarTempos() {
    let horaString;
    let minutoString;
    let segundoString;

    //Somar tempos das trilhas
    const total = tempoTrilhas.reduce((acc, curr) => {
      const [h, m, s] = curr.split(':');
      const hora = parseInt(h) * 3600;
      const minuto = parseInt(m) * 60;
      const segundo = parseInt(s);
      return acc + (hora + minuto + segundo);
    }, 0);

    //Converter em horas, minutos e segundos
    const hora = Math.floor(total / 3600);
    const minuto = Math.floor((total % 3600) / 60);
    const segundo = total % 60;

    //Converter em string
    horaString = hora.toString().length === 1 ? `0${hora}` : hora;
    minutoString = minuto.toString().length === 1 ? `0${minuto}` : minuto;
    segundoString = segundo.toString().length === 1 ? `0${segundo}` : segundo;

    setTotalTempo(`${horaString}:${minutoString}:${segundoString}`);
  }

  useEffect(() => {
    somarTempos();
  }, []);

  return (
    <TrilhaContainer>
      <h2>Trilhas</h2>
      <div>
        <Trilha>
          <Circle>
            <img src={trilhaImg} alt="Trilha" />
            <p>Trilha</p>
          </Circle>
          <LineTrilha width="12px" margin="1090px" />

          <CaminhoTrilha width="110px">
            <img src={infoImg} alt="" />
            <TrilhaItem isAcesso>
              <strong>
                {new Intl.NumberFormat('pt-BR').format(
                  dashboard?.totalAcessos ? dashboard.totalAcessos : 0,
                )}
              </strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Acessos</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="110px">
            <img src={infoImg} alt="" />
            <TrilhaItem isAcesso>
              <strong>
                {new Intl.NumberFormat('pt-BR').format(
                  dashboard?.totalAcessosUnique
                    ? dashboard.totalAcessosUnique
                    : 0,
                )}
              </strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Acessos Unique</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem>
              <strong className="identificacao">
                {new Intl.NumberFormat('pt-BR').format(
                  dashboard?.totalIdentificacao
                    ? dashboard.totalIdentificacao
                    : 0,
                )}
              </strong>
              <p>
                (iden/acess:{' '}
                {dashboard?.percentual?.identificacaoAcesso
                  ? dashboard.percentual.identificacaoAcesso
                  : 0}{' '}
                %)
              </p>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Identificação</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem>
              <strong>
                {new Intl.NumberFormat('pt-BR').format(
                  dashboard?.totalFundamentos ? dashboard?.totalFundamentos : 0,
                )}
              </strong>
              <p>
                (fund/ident:{' '}
                {dashboard?.percentual?.fundIdentificacao &&
                dashboard?.percentual?.fundIdentificacao !== 'NaN'
                  ? dashboard?.percentual?.fundIdentificacao
                  : 0}
                %)
              </p>
              <p>
                (fund/acess:{' '}
                {dashboard?.percentual?.fundamentacaoAcesso
                  ? dashboard?.percentual?.fundamentacaoAcesso
                  : 0}
                %)
              </p>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Fundamentação</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem>
              <strong>
                {new Intl.NumberFormat('pt-BR').format(
                  dashboard?.totalNegociacao ? dashboard?.totalNegociacao : 0,
                )}
              </strong>
              <p>
                (neg/fund:{' '}
                {dashboard?.percentual?.negFund &&
                Number(dashboard?.percentual.negFund) !== Infinity &&
                dashboard?.percentual?.negFund !== 'NaN'
                  ? dashboard?.percentual?.negFund
                  : 0}
                %)
              </p>
              <p>
                (neg/acess:{' '}
                {dashboard?.percentual?.negociacaoAcesso
                  ? dashboard?.percentual?.negociacaoAcesso
                  : 0}
                %)
              </p>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Negociação</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem>
              <strong>
                {new Intl.NumberFormat('pt-BR').format(
                  dashboard?.totalSelo ? dashboard?.totalSelo : 0,
                )}
              </strong>
              <p>
                (selo/neg:{' '}
                {dashboard?.percentual?.seloNeg &&
                dashboard?.percentual?.seloNeg !== 'NaN'
                  ? dashboard?.percentual?.seloNeg
                  : 0}
                %)
              </p>
              <p>
                (selo/acess:{' '}
                {dashboard?.percentual?.seloAcesso
                  ? dashboard?.percentual?.seloAcesso
                  : 0}
                %)
              </p>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Selo de acordo</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem>
              <strong>
                {new Intl.NumberFormat('pt-BR').format(
                  dashboard?.totalAcordos ? dashboard.totalAcordos : 0,
                )}
              </strong>
              <p>
                (acor/selo:{' '}
                {dashboard?.percentual?.acordoSelo &&
                dashboard?.percentual?.acordoSelo !== 'NaN'
                  ? dashboard?.percentual?.acordoSelo
                  : 0}
                % )
              </p>
              <p>(acor/acess: {dashboard?.percentual?.acordoAcesso}%)</p>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Acordos</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <Circle>
            <img src={raceImg} alt="Chegada" />
          </Circle>
          <LineTrilha width="1350px" />
        </Trilha>
      </div>

      {/* <div>
        <Line />
        <Trilha>
          <Circle>
            <img src={clockImg} alt="Tempo (Navegação)" />
            <p>Tempos</p>
            <p>(Navegação)</p>
          </Circle>

          <CaminhoTrilha width="110px">
            <img src={infoImg} alt="" />
            <TrilhaItem isAcesso>
              <strong>00:00:00</strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Acessos</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem isNavegacao>
              <p>Tempo médio</p>
              <strong>00:00:00</strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Identificação</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem isNavegacao>
              <p>Tempo médio</p>
              <strong>00:00:00</strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Fundamentação</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem isNavegacao>
              <p>Tempo médio</p>
              <strong>00:00:00</strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Negociação</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem isNavegacao>
              <p>Tempo médio</p>
              <strong>00:00:00</strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Selo de acordo</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <CaminhoTrilha width="176px">
            <img src={infoImg} alt="" />
            <TrilhaItem isNavegacao>
              <p>Soma dos tempos</p>
              <strong>00:00:00</strong>
            </TrilhaItem>
            <TrilhaFooter>
              <strong>Total</strong>
            </TrilhaFooter>
          </CaminhoTrilha>

          <Circle>
            <img src={raceImg} alt="Chegada" />
          </Circle>
        </Trilha>
      </div> */}
    </TrilhaContainer>
  );
}
